<script lang="ts">
    import { computed, ref, onMounted } from 'vue'

    import vm /*, { getLocalStorageItem, JourneyNode, removeLocalStorageItem, setLocalStorageItem }*/ from '../Journeys.viewmodel'

    // directives

    // utils
    // import { tmp_uuidv4 } from '../Journeys.viewmodel'

    import { JourneyStatus } from '@journeys/Enums'
    // import { cancelFrame, requestFrame } from '@cwd/shared/utils'
    // import { preview } from 'vite'

    // utils
    import { deepClone } from '@utils'
    import { api } from '@cwd/lib/main'

    import Tabs, { tab } from '@shared/components/Tabs.vue'
    import List from '@shared/components/List.vue'
    import JourneyListItem, { type Journey } from '../components/JourneyListItem.vue'
    import { journeysOrderOptions } from './JourneyStart.vue'
    import { CrossSVG } from '@cwd/shared/assets/vector/ui/IconsUI'

    /*
	interface JourneysTabData {
		list: { [key: string]: unknown | any }
		heading: string
		intro: string
		notification: string
	}
    */

    export default {
        name: 'Page: Journey New',
    }
</script>

<script lang="ts" setup>
    const { editor, activeJourney, /*startMenu, journeysMeta,*/ account } = vm

    onMounted(() => {
        getFiltered('Template')
    })

    const journeysTabs = {
        all: { name: 'all', display: $Resources.JourneysAllTabLabel },
        drafts: { name: 'drafts', display: $Resources.JourneysDraftsTabLabel },
        active: { name: 'active', display: $Resources.JourneysActiveTabLabel },
        ended: { name: 'ended', display: $Resources.JourneysEndedTabLabel },
    }

    const currentTab = ref('templates')

    const switchTab = (tab: string) => {
        if (tab === 'templates') getFiltered('Template')
        if (tab === 'copyprevious') getFiltered('all')

        currentTab.value = tab
        currentFilter.value = 'all'
    }

    /*
		const filters: any = {
			templates: {
				id: 'templates'
			},
			freetemplates: {
				id: 'freetemplates',
				subheading: 'Category',
				buttons: {
					all: {
						text: 'All'
					},
					newsletter: {
						text: 'Newsletter'
					},
					csm: {
						text: 'CSM'
					},
					signup: {
						text: 'Signup'
					}
				}
			},
			copyprevious: {
				subheading: 'Status',
				buttons: {
					all: {
						text: 'All'
					},
					draft: {
						text: 'Draft'
					},
					active: {
						text: 'Active'
					},
					ended: {
						text: 'Ended'
					}
				}
			}
		}
	    */

    const currentFilter = ref('all')

    const switchFilter = (filter: string) => {
        if (currentTab.value === 'copyprevious') getFiltered(filter)

        currentFilter.value = filter
    }

    let list = ref<Journey[]>([])

    const templatesList = () => {
        if (currentTab.value === 'templates') {
            return filteredList()
        } else {
            return []
        }
    }

    const previousList = () => {
        if (currentTab.value !== 'templates') {
            return filteredList()
        } else {
            return []
        }
    }

    const getFiltered = async (filter: string) => {
        let res = await account.listings.get(`/journeys`)

        if (filter === 'draft') {
            res = res.reduce((acc: any, item: any) => (item.Status === JourneyStatus.Draft && acc.push(item), acc), [])
        } else if (filter === 'active') {
            res = res.reduce((acc: any, item: any) => (item.Status === JourneyStatus.Active && acc.push(item), acc), [])
        } else if (filter === 'ended') {
            res = res.reduce((acc: any, item: any) => (item.Status === JourneyStatus.Ended && acc.push(item), acc), [])
        }

        list.value = res as Journey[]
    }

    const filteredList = () => {
        switch (currentTab.value) {
            case 'templates':
                list.value = account.listings.get(`/journeys/Templates`)
                return list.value as Journey[]
            case 'freetemplates':
                return []
            case 'copyprevious':
                return list.value as Journey[]
            default:
                return []
        }
    }

    const openJourney = async (journeyId: string) => {
        let clonedJourney = await api.post('/Journeys/Clone/' + journeyId).then((res: any) => res),
            data = JSON.parse(clonedJourney.GraphicalData)

        data.JourneyId = clonedJourney.JourneyId
        data.Status = clonedJourney.Status
        data.Title = clonedJourney.Title
        data.Description = clonedJourney.Description
        data.Tags = clonedJourney.Tags

        Object.assign(activeJourney, data)

        vm.router.push('/' + data.JourneyId)
    }

    const close = () => {
        vm.router.push('/drafts')
    }
</script>

<template>
    <header role="banner" class="p-lg-r p-lg-l">
        <div class="d-flex justify-content-between align-items-baseline">
            <h1>{{ $Resources.JourneysTemplatesHeading }}</h1>
            <a href="javascript:void(0)" @click.prevent="close" class="btn btn-subtle">
                <CrossSVG class="toolbar-icon m-xxs-r"></CrossSVG>
                {{ $Resources.CloseBtn }}
            </a>
        </div>
        <p class="m-lg-b">
            {{ $Resources.JourneysTemplatesIntroduction }}
        </p>
    </header>

    <tabs navClass="tabs list-unstyled m-lg-r m-lg-l">
        <tab :title="$Resources.JourneysTemplatesTabLabel" @tabClick="() => switchTab('templates')">
            <List
                itemId="JourneyId"
                :items="templatesList()"
                :loading="editor.state.busy"
                :filterKeys="['Title', 'Description']"
                :orderOptions="journeysOrderOptions()"
                displayAs="cards"
                :displayOptions="['default', 'cards']">
                <template #toolbar></template>
                <template #item="{ item, index }">
                    <JourneyListItem
                        :journey="item"
                        :index="index"
                        :tagList="account.listings.getMap('/tags')"
                        @journeyClicked="openJourney(item.JourneyId)"></JourneyListItem>
                </template>
            </List>
        </tab>
        <tab :title="$Resources.JourneysAsTemplatesTab" @tabClick="() => switchTab('copyprevious')">
            <List
                itemId="JourneyId"
                :items="previousList()"
                :loading="editor.state.busy"
                :filterKeys="['Title', 'Description']"
                :orderOptions="journeysOrderOptions()"
                displayAs="cards"
                :displayOptions="['default', 'cards']"
                :tabs="journeysTabs"
                :currentTab="currentFilter"
                @update:tab="(newVal) => switchFilter(newVal)">
                <template #toolbar></template>
                <template #item="{ item, index }">
                    <JourneyListItem
                        :journey="item"
                        :index="index"
                        :tagList="account.listings.getMap('/tags')"
                        @journeyClicked="openJourney(item.JourneyId)"
                        :hideStats="true"></JourneyListItem>
                </template>
            </List>
        </tab>
    </tabs>
</template>

<style>
    /*
    .card-content:has(.ug-bars) {
		display: none !important;
	}
    */
</style>
